var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-ads-view"},[_c('page-title',{attrs:{"title":'Información'}}),_c('filters-bar',{attrs:{"section":'info'}}),_c('google-map',{attrs:{"markers":_vm.markers}}),_c('ads-list',{attrs:{"section":'info'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }